<template>
</template>

<script>
export default {
    data: function () {
        return {
            disableOnSubmit: false,
            success: false,
            emailAlreadyUsed: false,
            showAddCardForm: false,
            showEditCardForm: false,
            showUploadControls: false,
            showCardControls: false,
            visibleCards: this.cards,
            newCard: this.card,
            stripeForm: {
                name: '',
                card_name: '',
                card_number: '',
                card_expiry: '',
                card_cvc: '',
            },
        }
    },
    props: [
        'editSettingsUrl',
        'changePasswordUrl',
        'saveNewCardUrl',
        'editCardUrl',
        'deleteCardUrl',
        'user',
        'card',
        'cards',
        'stripeKey',
    ],

    mounted() {
        let self = this;
        setTimeout(function () {
            self.stripe = Stripe(self.stripeKey);
            self.setUpStripePay();
        }, 3000);
    },

    methods: {
        submitGeneralDetails() {
            let postData = {
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                phone: this.user.phone,
                email: this.user.email,
            }

            this.$validator.validateAll('general-details-form').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.saveGeneralDetails(postData);
                }
            });

        },

        saveGeneralDetails(postData) {
            axios
            .post(this.editSettingsUrl, postData)
            .then(response => {
                // show the success message
                this.$store.dispatch('setMessage', {
                    text: 'Your settings have been saved.',
                    type: 'success'
                })

            })
            .catch(error => {
                this.handleError(error.response.data);
            });
        },

        submitPassword() {
            let postData = {
                current_password: this.user.current_password,
                new_password: this.user.new_password,
                new_password_confirmation: this.user.new_password_confirmation,
            }
            this.$validator.validateAll('change-password-form').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.savePassword(postData);
                }
            });

        },

        savePassword(postData) {
            axios
            .post(this.changePasswordUrl, postData)
            .then(response => {
                // show the success message
                this.$store.dispatch('setMessage', {
                    text: 'Your password has been updated',
                    type: 'success'
                })
            })
            .catch(error => {
                this.handlePasswordError(error.response.data);

            });
        },

        validationClass(hasErrors) {
            return this.$parent.validationClass(hasErrors);
        },

        handleError(response) {
            // Custom handle error method for handling the case where the email inspect
            // already taken by a user in the database.

            if ('email' in response.errors) {
                this.emailAlreadyUsed = true;
            }
        },

        nonUniqueEmail() {
            if (this.emailAlreadyUsed == true) {
                return 'is-invalid';
            }
        },

        handlePasswordError(response) {
            // show the success message

            var errors = response.errors;
            var fullErrorMessage = '';

            // Loop through error messages to make full flash message.
            for (var key in errors) {
                if (errors.hasOwnProperty(key)) {
                    fullErrorMessage = fullErrorMessage + errors[key];
                }
            }

            this.$store.dispatch('setMessage', {
                text: fullErrorMessage,
                type: 'danger'
            })
        },

        showAddNewCardForm() {
            this.card.card_name = '';
            this.card.card_number = '';
            this.card.card_expiry = '';
            this.card.card_cvc = '';
            this.showAddCardForm = true;
            this.showEditCardForm = false;
            // Scroll to top of section

            $('html, body').animate({
               scrollTop: $('.new-payment').offset().top + 100
            }, 1000);
        },

        submitNewCard() {
            let postData = {
                card_name: this.card.card_name,
                card_number: this.card.card_number,
                card_expiry: this.card.card_expiry,
                card_cvc: this.card.card_cvc
            }

            this.$validator.validateAll('new-card-form').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.saveNewCard(postData);
                }
            });
        },

        saveNewCard(postData) {
            axios
            .post(this.saveNewCardUrl, postData)
            .then(response => {
                this.visibleCards = response.data.data;
                this.showAddCardForm = false;
                this.card.card_name = '';
                this.card.card_number = '';
                this.card.card_expiry = '';
                this.card.card_cvc = '';
                // show the success message
                this.$store.dispatch('setMessage', {
                    text: 'Your card has been saved',
                    type: 'success'
                })
            })
            .catch(error => {
                this.handleSaveNewCardError(error.response.data);

            });
        },

        handleSaveNewCardError(response) {
            this.$store.dispatch('setMessage', {
                text: 'Your there has been an error saving your card',
                type: 'success'
            })
        },

        showEditExistingCardForm(cardHashid, cardName, cardExpiry) {
            this.card.card_name = cardName;
            this.card.card_expiry = cardExpiry;
            this.card.card_hashid = cardHashid;
            this.showEditCardForm = true;
            this.showAddCardForm = false;
            // Scroll to top of section
            $('html, body').animate({
               scrollTop: $('.edit-card').offset().top + 100
            }, 1000);
        },

        submitEditExistingCard() {
            let postData = {
                hashid: this.card.card_hashid,
                card_name: this.card.card_name,
                card_expiry: this.card.card_expiry,
            }

            this.$validator.validateAll('edit-card-form').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.updateExistingCard(postData);
                }
            });
        },

        updateExistingCard(postData) {
            axios
            .post(this.editCardUrl, postData)
            .then(response => {
                this.visibleCards = response.data.data;
                this.showEditCardForm = false;
                this.card.card_hashid = '';
                this.card.card_name = '';
                this.card.card_expiry = '';
                // show the success message
                this.$store.dispatch('setMessage', {
                    text: 'Your card has been updated',
                    type: 'success'
                })
            })
            .catch(error => {
                this.handleUpdateExistingCardError(error.response.data);
            });
        },

        handleUpdateExistingCardError(response) {
            this.$store.dispatch('setMessage', {
                text: 'Your there has been an error updating your card',
                type: 'success'
            })
        },

        submitDeleteCard(hashid) {
            let postData = {
                hashid: hashid,
            }

            this.$validator.validateAll('delete-card-form').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.deleteCard(postData);
                }
            });
        },

        deleteCard(postData) {
            axios
            .delete(this.deleteCardUrl, {data: postData})
            .then(response => {
                this.visibleCards = response.data.data;

                // show the success message
                this.$store.dispatch('setMessage', {
                    text: 'Your card has been deleted',
                    type: 'success'
                })
            })
            .catch(error => {
                this.handleDeleteCardError(error.response.data);
            });
        },

        handleDeleteCardError(response) {
            this.$store.dispatch('setMessage', {
                text: 'Your there has been an error deleting your card',
                type: 'success'
            })
        },

        /* Start Stripe functionality */
        setUpStripePay() {
            if (document.getElementById("stripe-card-number")
                && document.getElementById("stripe-card-expiry")
                && document.getElementById("stripe-card-cvc")) {

                this.elements = this.stripe.elements({
                    fonts: [
                        {
                            cssSrc: 'https://fonts.googleapis.com/css?family=Roboto',
                        },
                    ],
                    locale: 'auto'
                });

                var elementStyles = {
                    base: {
                        color: '#333333',
                        fontWeight: 400,
                        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                        fontSize: '16px',
                        fontSmoothing: 'antialiased',

                        ':focus': {
                            color: '#333333',
                        },

                        '::placeholder': {
                            color: '#c6c6c6',
                        },

                        ':focus::placeholder': {
                            color: '#c6c6c6',
                        },
                    },
                    invalid: {
                        color: '#f27268',
                        ':focus': {
                            color: '#f27268',
                        },
                        '::placeholder': {
                            color: '#c6c6c6',
                        },
                    },
                };

                var elementClasses = {
                    focus: 'focus',
                    empty: 'empty',
                    invalid: 'invalid',
                };

                var cardNumber = this.elements.create('cardNumber', {
                    style: elementStyles,
                    classes: elementClasses,
                });
                cardNumber.mount('#stripe-card-number');

                var cardExpiry = this.elements.create('cardExpiry', {
                    style: elementStyles,
                    classes: elementClasses,
                });
                cardExpiry.mount('#stripe-card-expiry');

                var cardCvc = this.elements.create('cardCvc', {
                    style: elementStyles,
                    classes: elementClasses,
                });
                cardCvc.mount('#stripe-card-cvc');

                this.registerElements([cardNumber, cardExpiry, cardCvc], 'form-holder');
            }
        },

        registerElements(elements, formName) {
            var formClass = '.' + formName;
            var example = document.querySelector(formClass);
            var form = example.querySelector('form');
            var error = form.querySelector('.error');
            var errorMessage = error.querySelector('.message');

            var self = this;

            // Listen for errors from each Element, and show error messages in the UI.
            var savedErrors = {};

            elements.forEach(function(element, idx) {
                element.on('change', function(event) {
                    if (event.error) {
                        error.classList.add('visible');
                        savedErrors[idx] = event.error.message;
                        errorMessage.innerText = event.error.message;
                    } else {
                        savedErrors[idx] = null;

                        // Loop over the saved errors and find the first one, if any.
                        var nextError = Object.keys(savedErrors)
                                              .sort()
                                              .reduce(function(maybeFoundError, key) {
                                                  return maybeFoundError || savedErrors[key];
                                              }, null);

                        if (nextError) {
                            // Now that they've fixed the current error, show another one.
                            errorMessage.innerText = nextError;
                        } else {
                            // The user fixed the last error; no more errors.
                            error.classList.remove('visible');
                        }
                    }
                });
            });

            // Listen on the form's 'submit' handler...
            form.addEventListener('submit', function(e) {
                e.preventDefault();

                self.stripe.createPaymentMethod(
                    'card',
                    elements[0]
                ).then(function(result) {
                    if (result.error) {
                        // Show error in payment form
                    } else {
                        console.log(result);
                        self.createCard(result.paymentMethod.id);
                    }
                });
            });
        },

        createCard(paymentMethodId) {
            let postData = new FormData();
            postData.append('payment_method_id', paymentMethodId);

            axios
                .post(this.saveNewCardUrl, postData)
                .then(response => {
                    this.visibleCards = response.data.data;
                    this.showAddCardForm = false;
                    this.stripeForm.card_name = '';
                    // show the success message
                    this.$store.dispatch('setMessage', {
                        text: 'Your card has been saved',
                        type: 'success'
                    })
                    location.reload();
                })
                .catch(error => {
                    this.handleSaveNewCardError(error.response.data);
                });
        },

    },
    components: {
    }
}
</script>
